function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import '../../../common/utils/polyfills';
import React from 'react';
import GalleryContainer from './galleryContainerNew.js';
import utils from '../../../common/utils';
import { viewModeWrapper } from '../../../common/window/viewModeWrapper';
import window from '../../../common/window/windowWrapper';
import { GalleryComponent } from '../../galleryComponent';
import '../../../versionLogger';

var ProGallery =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ProGallery, _GalleryComponent);

  function ProGallery(props) {
    var _this;

    _this = _GalleryComponent.call(this) || this;
    var isSSR = !!window.isMock;
    _this.canRender = !isSSR || props.allowSSR === true; //do not render if it is SSR

    if (_this.canRender) {
      _this.init(props);
    }

    if (utils.isLocal() && !utils.isTest()) {
      console.warn('PRO GALLERY DEV');
    }

    return _this;
  }

  var _proto = ProGallery.prototype;

  _proto.init = function init(props) {
    if (typeof props.viewMode !== 'undefined') {
      viewModeWrapper.setViewMode(props.viewMode);
    }

    this.domId = props.domId || Math.floor(Math.random() * 10000);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.viewMode !== nextProps.viewMode) {
      viewModeWrapper.setViewMode(nextProps.viewMode);
    }
  };

  _proto.render = function render() {
    return this.canRender && React.createElement("div", {
      id: "pro-gallery-" + this.domId,
      className: "pro-gallery"
    }, React.createElement(GalleryContainer, _extends({}, this.props, {
      domId: this.domId,
      items: this.props.items || [],
      watermarkData: this.props.watermarkData,
      settings: this.props.settings || {},
      offsetTop: this.props.offsetTop,
      itemsLoveData: this.props.itemsLoveData || {}
    })));
  };

  return ProGallery;
}(GalleryComponent);

export { ProGallery as default };